import './index.scss'

import React from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'

import Icon from '../../components/Icon'


const bem = new BEMHelper('list')

export default function List({
  title,
  items,
  large,
  small,
  inline,
  table,
  circle,
}) {
  return (
    <div {...bem('', { large, inline, small, table })}>
      {title && <h3 {...bem('title')}>{title}</h3>}

      <ul {...bem('list')}>
        {items.map((item) => (
          <li {...bem('item')} key={item}>
            {!table && (
              <>
                {circle ? (
                  <span {...bem('item-circle')}></span>
                ) : (
                  <Icon icon="sensor" {...bem('check')} />
                )}
              </>
            )}
            {item}
          </li>
        ))}
      </ul>
    </div>
  )
}

List.propTypes = {
  items: T.array.isRequired,
  name: T.string,
  title: T.string,
  large: T.bool,
  inline: T.bool,
  small: T.bool,
  table: T.bool,
}
